<template>
    <article
        class="card-plan-item"
        no-body
    >
        <div class="card-body">
            <h4 class="card-title mb-2">
                {{ plan.titulo }}
            </h4>
        </div>
        <div class="card-body py-0">
            <cloud-plan-price
                :price="plan.total_real"
                :currency="plan.moeda.toLowerCase()"
                :time="(this.view.translation.recurrence_cycle[plan.periodo] || this.view.translation.recurrence_cycle['MENSAL']).toLowerCase()"
                :fake_amount="plan.fake_amount"
                :transtation="view.translation"
            />
        </div>
        <div class="card-body card-border-bottom">
            <p class="plan-description">
                {{ plan.descricao }}
            </p>
        </div>
        <div class="card-body py-0">
            <ul class="plan-items py-0 mb-0">
                <li v-if="plan.first_month_value != null && plan.first_month_value != undefined">
                    <div class="svg glyphicon glyphicon-info-sign"
                         data-toggle="tooltip" data-placement="bottom"
                        :title="tooltipInfo"/>
                    <div class="plan-description">
                        <div class="additional" v-html="currencySymbol() + ' ' + plan.first_month_value + ' ' + `<div style='color: #434343;margin-left: 5px;font-size: 12px;text-shadow: 0.5px 0.5px 0.5px #434343;opacity: 0.65;'> - ${view.translation.builderall_plano_mensal_2tier_primeiro_mes.toLowerCase()}</div>`"></div>
                    </div>
                </li>
                <li v-if="plan.additional_value_first_month != null && plan.additional_value_first_month != '0.00'">
                    <div class="svg glyphicon glyphicon-info-sign"
                         data-toggle="tooltip" data-placement="bottom"
                         :title="tooltipInfo"/>
                    <div class="plan-description">
                        <div class="additional" v-html="currencySymbol() + ' ' + totalValue() + ' ' + `<div style='color: #434343;margin-left: 5px;font-size: 12px;text-shadow: 0.5px 0.5px 0.5px #434343;opacity: 0.65;'> - ${view.translation.builderall_plano_mensal_2tier_primeiro_mes.toLowerCase()}</div>`"></div>
                    </div>
                </li>
                <li
                    v-for="(PlanItem, index) in itens"
                    :key="index" v-if="shwoItem(PlanItem.id_recurso)"
                >
                    <div class="svg">
                        <svg
                            preserveAspectRatio="xMidYMax meet"
                            height="18"
                            width="18"
                            viewBox="0 0 18.602 18.602"
                        ><path
                            id="Caminho_407"
                            data-name="Caminho 407"
                            d="M13.3,4a9.3,9.3,0,1,0,9.3,9.3A9.3,9.3,0,0,0,13.3,4Zm4.611,8.454-4.9,4.9a1.329,1.329,0,0,1-1.88,0L8.687,14.909A1.329,1.329,0,0,1,8.9,12.853a1.352,1.352,0,0,1,1.687.2l.492.492a.734.734,0,0,1,0,1.04h0a.332.332,0,0,0,0,.468h0a.332.332,0,0,0,.468,0l.525-.525h0l3.933-3.93a1.352,1.352,0,0,1,1.687-.2,1.329,1.329,0,0,1,.216,2.056Z"
                            transform="translate(-4 -4)"
                            fill="#0080fc"
                        /></svg>
                    </div>
                    <div class="plan-description">
                        <div v-if="PlanItem.titulo == 'label_back_office_tools_package'"
                             data-toggle="popover" :data-placement="view.LANG_IS_RTL ? 'left' : 'right'" data-html="true"
                             :data-content="`${newTools.join('<br/>')}`"
                             class="feature-is tools" style='color: #0F7BFF;' v-html="PlanItem.label"></div>
                        <div v-else class="feature-is text" v-html="checkUnlimitedDomains(PlanItem)"></div>
                        <span v-if="PlanItem.titulo != 'label_back_office_tools_package'">{{ PlanItem.label_desc }}</span>
                    </div>
                </li>
                <li v-if="plan.wordpress_server != null ">
                    <img class="svg" src="/internacional/public/office5/img/general-png/wordpress.png"/>
                    <div class="plan-description">
                        <div class="feature-is wordpress-items" v-html="plan.wordpress_server"></div>
                    </div>
                </li>
                <li v-if="showAditionalInfo">
                  <i class="glyphicon glyphicon-info-sign"></i>
                  <div class="plan-description">
                    <div class="feature-is wordpress-items" style="text-align: center" v-html="optionsToHide[optionsToHide.findIndex( x => x.title == 'additional_information')]['input-description']"></div>
                  </div>
                </li>
            </ul>
        </div>
        <footer class="card-footer ">
            <a  v-if="view.FATHER_IS_BUILDERALL"
                block
                size="lg"
                class="btn justify-content-center bw-upgrade"
                :href="plan.checkout"
            >
                {{ view.translation.label_selecionar }}
            </a>
            <buton v-else
                   @click="submitPlan()"
                   class="btn justify-content-center bw-upgrade">
              {{ view.translation.label_selecionar }}
            </buton>
        </footer>
    </article>
</template>

<script>
import CloudPlanPrice from './PlanListItemPrice'
export default {
    components: {
        CloudPlanPrice
    },
    props: {
        plan: {
            type: Object,
            default: () => {}
        },
        view: {
            type: Object,
        }
    },
    data() {
        return {
            itens: [],
            newTools: [],
            optionsToHide: []
        }
    },
    mounted() {
        this.availableTools()
        this.itensToShow()
        this.optionsToHide = this.plan.options_to_hide
    },
    methods: {
        itensToShow() {
            let itens = []
            if (this.plan.itens != undefined) {
                for (let i = 0; i < this.view.plan_itens_to_show.length; i++) {
                    for (let a = 0; a < this.plan.itens.length; a++) {
                        if (this.view.plan_itens_to_show[i] == this.plan.itens[a].id_recurso) {
                            itens.push(this.plan.itens[a])
                        }
                    }
                }
            }
            this.itens = itens
        },
        currencySymbol() {
            const currency = {
                brl: 'R$',
                usd: '$',
                eur: '€',
                gbp: '£',
                czk: 'Kč',
                inr: '&#8377',
                thb: '฿',
            }[this.plan.moeda.toLowerCase()];

            return currency || this.plan.moeda.toUpperCase();
        },
        totalValue() {
            let additional_value_first_month = parseFloat(this.plan.additional_value_first_month)
            return (additional_value_first_month + this.plan.total_real).toFixed(2)
        },
        availableTools() {
            let newTools = []
            for (let i = 0; i < this.plan.available_tools.length; i++) {
                newTools[i] =  "<i class='fa fa-check-circle' style='color: #0080FC;'></i> " + this.plan.available_tools[i]
            }
            this.newTools = newTools
        },
        submitPlan() {
          $("<form/>", {
            action: '',
            method: 'POST',
            name: 'upgrade'
          }).appendTo('body');

          $('form[name=upgrade]').append('<input type="hidden" name="plano" value="' + this.plan.id + '">');

          $('form[name=upgrade]').submit();
        },
        shwoItem(item) {
          let index = null,
              show = true

          try {
            if (!isEmpty(this.optionsToHide)) {
              index = this.optionsToHide.findIndex( x => x.resource_id == item);
              show = index != -1 ? !this.optionsToHide[index].checkbox : true
            }
          } catch (e) {
            throw new Error('Mensagem', { cause : e })
          }

          return show;
        },
        checkUnlimitedDomains(data) {
          return (data.id_recurso == '3' && data.qtde == '999.00') ? this.view.translation.upgrade_unlimited_domains : data.label
        }
    },
    computed: {
        tooltipInfo() {
            let translation
            if (this.plan.first_month_value != null && this.plan.first_month_value != undefined) {
                translation = this.view.translation.office_upgrade_info.replace('{first_payment}', this.currencySymbol() + ' ' + this.plan.first_month_value).replace('{last_payment}', this.currencySymbol() + ' ' + this.plan.total_real.toFixed(2))
            } else {
                translation = this.view.translation.office_upgrade_info.replace('{first_payment}', this.currencySymbol() + ' ' + this.totalValue()).replace('{last_payment}', this.currencySymbol() + ' ' + this.plan.total_real.toFixed(2))
            }
            return translation
        },
      showAditionalInfo() {
        let show = false,
            index = null;

        if (!isEmpty(this.optionsToHide)) {
          index = this.optionsToHide.findIndex( x => x.title == 'additional_information');

          if (show = index != -1 && !isEmpty(this.optionsToHide[index]['input-description'])) {
            return show = index != -1 ? !this.optionsToHide[index].checkbox : false
          }
          return false
        }
      }
    }
}
</script>
<style>
.popover {
    width: 90%;
}
.popover-content {
    text-align: initial;
    max-height: 60vh;
    overflow: auto;
}
.popover.right>.arrow:after {
}
</style>
<style lang="scss">
.card-plan-item {
    box-shadow: 0px 3px 5px #00000026;
    border-radius: 10px;
    text-align: center;
    min-height: 400px;
    margin-bottom: 40px;
    height: calc(100% - 40px);
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    .card-title {
        margin-top: 0.6em;
        font: normal normal 800 1.8rem/38px Muli;
        color: #434343;
    }
    .card-body {
        flex: 1 1 auto;
        min-height: 1px;
        padding: 0 1.25rem;
        .plan-description {
            font: normal 600 normal 0.82rem/18px Muli;
            letter-spacing: 0.42px;
            color: #434343;
        }
        .plan-items {
            list-style-type: none;
            border-bottom: 1px solid #EBEBEC;
            li {
                height: auto;
                font: normal normal normal 1.05rem/22px Muli;
                text-align: left;
                color: #434343;
                padding: 15px 0;
                max-width: 230px;
                margin: auto;
                display: flex;
                align-items: center;
                &:not(:last-child) {
                    border-bottom: 1px solid #E3E3E3; /* #EBEBEC; */
                    border-bottom-style: dotted;
                }
                .additional {
                    color: #0080FC;
                    display: inline-flex;
                }
                .glyphicon {
                    color: #0080FC;
                    font-size: 19px;
                }
                .tools {
                    cursor: pointer;
                }
                .text {
                    text-transform: uppercase;
                }
                .svg {
                    width: 18px !important;
                    height: 18px !important;
                    margin-right: .5em;
                    margin-top: -2px;
                }
                span {
                    color: #434343;
                    font-size: 12px;
                    font-weight: 700;
                    font-family: 'Muli-Bold';
                    opacity: .447;
                    fill: #535353;
                }
            }
        }
        .wordpress-items {
            opacity: 0.85;
            font-size: 12px;
        }
    }
    .card-footer {
        background: #fff;
        border: none;
        padding: 1rem 2.25rem 1.5rem;
        border-radius: 10px;
        .btn {
            box-shadow: 0px 4px 16px #21274b39;
            padding: 1em;
            max-width: 215px;
            width: 100%;
            background-color: #0F7BFF;

            color: #ffffff;
            font-size: 1rem;
            font-weight: bold;
            text-transform: uppercase;
        }
    }
    .card-border-bottom {
        border-bottom: 1px solid #EBEBEC;
    }
    &.card-plan-item-current {
        padding-bottom: 1.25rem;
        .card-header {
            font: normal normal bold 18px/26px Muli;
            color: #0F7BFF;
            text-transform: uppercase;
            padding: 22px;
        }
        .card-body {
            opacity: .65;
        }
        .card-footer {
            display: none;
        }
        .plan-items {
            border: none;
        }
    }
}
.py-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}
.mb-0 {
    margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/upgrade/PlanListItem.vue